import axios from "axios"
import { port } from "../CommonComponents/CommonWorkers";

let address = window.location.protocol + "//" + window.location.hostname + port  + "/api"
const isDebug = process.env.NODE_ENV === "development" ? true : false;
if(isDebug) {
    address = window.location.protocol + "//" + "172.22.10.14" + port
}

export const getDiarysList = async () =>{
    const diarys = (await axios.get(`${address}/getDiarysList`)).data;
    console.log(diarys)
    return diarys;
}

export const getDailyList = async (isNew = 0) =>{
    const dailys = (await axios.get(`${address}/daily/getList`, {params: {isNew: isNew}})).data;
    console.log(dailys)
    return dailys;
}

export const getDiaryPosts = async (id) =>{
    const diarys = (await axios.get(`${address}/getDiaryPosts`,{params: {ID: id}})).data;
    console.log(diarys)
    return diarys;
}
export const getDailyPosts = async (id, start, count) =>{
    const dailys = (await axios.get(`${address}/daily/getPosts`,{params: {ID: id,start: start,  count: count}})).data;
    console.log(dailys)
    return dailys;
}
export const createDiaryPost = async (diaryId, header = "TestHeader", content) =>{
    const postId = (await axios.post(
        `${address}/createDiaryPost`,
        {
            diaryId: diaryId,
            header: header,
            content: content
        })
        ).data;
    console.log(postId)
    return postId;
}

export const createDailyPost = async (noteId, tabId, header = "", content, dateOffset) =>{
    const postId = (await axios.post(
        `${address}/daily/createPost`,
        {
            noteId: noteId,
            tabId: tabId,
            header: header,
            content: content,
            dateOffset: dateOffset
        })
        ).data;
    console.log(postId)
    return postId;
}

export const updateDiaryPost = async (id, diaryId, header = "TestHeader", content, dateOffset) =>{
    const postId = (await axios.post(
        `${address}/editDiaryPost`,
        {
            id: id,
            diaryId: diaryId,
            header: header,
            content: content,
            dateOffset: dateOffset,
        })
        ).data;
    console.log(postId)
    return postId;
}

export const updateDailyPost = async (noteId, tabId, header = "", content,dateOffset) =>{
    const postId = (await axios.post(
        `${address}/daily/editPost`,
        {
            noteId: noteId,
            tabId: tabId,
            header: header,
            content: content,
            dateOffset: dateOffset,
        })
        ).data;
    console.log(postId)
    return postId;
}


export const createDiary = async (name) =>{
    const postId = (await axios.post(
        `${address}/createDiary`,
        {
            name: name
        })
        ).data;
    console.log(postId)
    return postId;
}
export const createTab = async (name) =>{
    const id = (await axios.post(
        `${address}/daily/createTab`,
        {
            name: name
        })
        ).data;
    console.log(id)
    return id;
}

export const editTab = async (id, name) =>{
    const editId = (await axios.post(
        `${address}/daily/editTab`,
        {
            id: id,
            name: name
        })
        ).data;
    console.log(editId)
    return editId;
}
export const deleteTab = async (id) =>{
    await axios.post(
        `${address}/daily/deleteTab`,
        {id: id})
}

export const deleteDiaryPost = async (id) =>{
    await axios.post(
        `${address}/deleteDiaryPost`,
        {id: id})
}
export const deletePost = async (id) =>{
    const res = await axios.post(
        `${address}/daily/deletePost`,
        {id: id})
    return res;
}


export const getDateTimeFromISOString = (isoDate) => {
    if (!isoDate) {
        return [null, null];
    }
    let date = new Date(isoDate).toLocaleDateString();
    let time = new Date(isoDate).toLocaleTimeString();
    return [date, time];
};

const generateSessionUid = function () { // Public Domain/MIT
    var d = new Date().getTime();//Timestamp
    var r = Math.random() * 1000;//random number between 0 and 1000
    var d2 = (performance && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return `${d}_${r}`;
}

export const sessionUid = generateSessionUid();